document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-m-founder-story]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    if (section.dataset.mFounderStoryInit === 'true') return;
    section.dataset.mFounderStoryInit = 'true';

    var revealItems = section.querySelectorAll('.m-founder-story__reveal');
    if (!revealItems.length) return;

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealItems.forEach(function (item) {
      observer.observe(item);
    });
  });
});